import React from 'react';
import { FeaturesContainer } from '../Features';
import { useScrollToFeature } from '../hooks/useScrollToFeature';

interface FeaturesSectionWrapperProps {
  card: any;
  targetFeatureId?: string | null;
  targetProductId?: string | null;
  forceExpanded?: boolean;
  isOpen?: boolean;
}

/**
 * Features Section Wrapper Component (Read-Only)
 * Displays features data without any edit/update capabilities
 * Simple read-only view of features for the moment
 */
export const FeaturesSectionReadonlyWrapper: React.FC<
  FeaturesSectionWrapperProps
> = ({ card, targetFeatureId, targetProductId, forceExpanded, isOpen }) => {
  // Scroll to specific feature when targetFeatureId is provided
  useScrollToFeature({
    targetFeatureId,
    isEnabled: forceExpanded,
    delay: 600
  });

  return (
    <FeaturesContainer
      issueId={card?.issueId}
      momentName={card?.name || card?.title}
      targetFeatureId={targetFeatureId}
      targetProductId={targetProductId}
      forceExpanded={forceExpanded}
      readonly={true}
      hideCommentIcon={true}
      isOpen={isOpen}
    />
  );
};

export default FeaturesSectionReadonlyWrapper;
